<template>
	<div  v-show="bodyIsShow">
		<!--<mt-cell v-for="n in 10" :title="'content ' + n" />-->
		<div  class="bigbodywrap">
			<section id="formwrapSection" class="formwrapSection clearfix bac" >
				<div class="formwrap">
					<div id="signUpfrom" class="signUpfrom" style="background: #fff;">
						<!--<input type="hidden" id="groupbyNum" name="groupbyNum" :value="periodsInfo.id" />
						<input type="hidden" id="position" name="position" value="1" />
						<input type="hidden" id="groupbyType" name="groupbyType" value="1" />-->
						<div  :class="['sinformTotalPriceLoad',{heightInfo:!showLoadContent}]" >
							<div  class="sinformTotalPriceLeft">
								<div  class="sinformTit"  v-if="showLoadContent">贷款总价（元）</div>
								<div  class="sinformTit" v-else>全款总价（元）</div>
								<div  class="sinformTotalPri">{{totalPricesShow}}</div>
							</div>
							<div class="sinformDetails" v-if="showLoadContent">
									<div>
										<p>首付(元)</p>
										<p class="bigsize">{{downPaymentsShow}}</p>
									</div>
									<div>
										<p>参考月供(元)</p>
										<p class="bigsize">{{payMonthlysShow}}</p>
									</div>
									<div>
										<p>贷款额度(元)</p>
										<p class="bigsize">{{loanLimitsShow}}</p>
									</div>
									<div>
										<p>利息(元)</p>
										<p class="bigsize">{{interestsShow}}</p>
									</div>
							</div>
						</div>
						<div class="sinform"  style="margin-top: 0.1rem;">
                            <em class="fontColorTit">选择车款</em>
                            <div @click="settlementBtn(1)" class="sinform-text fontColorVal" id="insertCarinfo" >{{carAllNames}}</div>
                            <!--:style="{'color':selectColor}"-->
                            <div class="icon-arror-r"></div>
                        </div>
                        <div class="sinformBotLine"></div>
		                <div class="sinform">
		                    <em class="fontColorTit">裸车价格</em>
		                    <!--<input type="text" v-model="nakedPrice" @focus="setFocusIndex()"  class="sinform-text fontColorVal" name="usernane" placeholder="裸车价格" maxlength="10" id="usernane" >-->
		                    <input type="text" v-model="carPricesShow"  class="sinform-text fontColorVal" name="usernane" placeholder="裸车价格" maxlength="8" id="usernane" >
		                    <em style="margin-left: 0.2rem;">元</em>
		                </div>
		                <div class="sinformBotLine"></div>
		                <div v-if="showLoadContent">
			                <div class="sinform">
	                            <em class="fontColorTit">首付比例</em>
	                            <div @click="settlementBtn(3)" class="sinform-text" id="selectCarPay" style="color: #333;">{{downPaymentRatios}}%</div>
	                            <div class="icon-arror-r"></div>
	                        </div>
	                        <div class="sinformBotLine"></div>
	                        <div class="sinform">
	                            <em class="fontColorTit">还款年限</em>
	                            <div @click="settlementBtn(4)" class="sinform-text" id="selectCarYear" style="color: #333;">{{loanTerms/12}}年</div>
	                            <input type="text" hidden="hidden" id="loanTermId"/>
	                            <div class="icon-arror-r"></div>
	                        </div>
	                        <div class="sinformBotLine"></div>
		                </div>
		                <div class="sinform">
		                    <em class="fontColorTit">必要花费</em>
		                    <input type="text" v-model="necPricesShow" class="sinform-text fontColorVal" name="usernane" placeholder="必要花费" maxlength="10" id="usernane" >
		                    <em style="margin-left: 0.2rem;">元</em>
		                </div>
		                <div class="sinform" style=" height: 1rem;line-height: 1rem;display: flex;justify-content: space-between;" @click="unfold">
		                	<em  class="sinform-open-left">购置税、交强险等</em>
		                	<em  class="sinform-open-right" v-text="isTakeupCon?'收起 -':'展开详细 +'"></em>
		                </div>
		                <div v-show="isTakeupCon">
		                	<div class="sinform">
			                    <em  class="fontColorTits">购置税</em>
			                    <input type="text" v-model="vehiclePurchaseTaxesesShow" class="sinform-text fontColorVal" name="usernane" placeholder="购置税" maxlength="10" id="usernane" >
			                </div>
			                <div class="sinform">
	                            <em   class="fontColorTits">交强险</em>
	                            <div @click="settlementBtn(5)" class="sinform-text fontColorVal" id="selectCarInsu" >{{salisShow}}</div>
	                            <input type="text" hidden="hidden"  id="selectCarInsuId"/>
	                            <!--:style="{'color':insuColor}"-->
	                            <div class="icon-arror-r"></div>
	                        </div>
	                        <div class="sinform">
	                            <em class="fontColorTits" >车船使用税</em>
	                            <div @click="settlementBtn(6)" class="sinform-text sinform-text2 fontColorVal" id="selectCarTax" >{{vehicleVesselTaxsShow}}</div>
	                            <input type="text" hidden="hidden" id="selectCarTaxId"/>
	                            <!--:style="{'color':useTaxColor}"-->
	                            <div class="icon-arror-r"></div>
	                        </div>
	                        <div class="sinform">
			                    <em  class="fontColorTits">上牌费用</em>
			                    <input type="text" v-model="regPricesShow" class="sinform-text fontColorVal" name="usernane" placeholder="上牌费用" maxlength="10" id="usernane" >
			                    <em style="margin-left: 0.2rem;margin-left: 0.13rem;" class="signUpfrom-icon-open"></em>
			                </div>
		                </div>
					</div>
					<div class="sinformReference" v-show="showLoadContent">
		                	<p>1、此结果仅供参考，实际应缴费用以当地为准</p>
		                	<p>2、分期方案利率参考：1年期4.85%；2年期5.25%；</p>
		                	<p>3年期5.25%；4年期5.25%；5年期5.25%。具体分期</p>
		                	<p>金融方案供参考，以合作的金融机构为准</p>
		                </div>
					<div v-show="!showLoadContent" style="margin-bottom:1em;color: #bdbdbd;" class="addxyroom posLocation" >*此结果仅供参考，实际应缴费用以当地为准</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	import { Toast } from 'mint-ui';
import MsgBus from "../../../assets/bus/bus.js"
export default {
	name: 'fullSection',
//	props: ["result"],	//prop传值
	data:function() {
		return {
			bodyIsShow:false,
//			carBrand:'奥迪A4L30周年 进取型',
			isTakeupCon:false,
			objData:{},
			pageStatus:false,
			state:'0',
			showLoadContent:false,
			brandIds:'',
			brandNames:'',
			styleIds:'',
			styleNames:'',
			styleSeriesIds:'',
			styleSeriesNames:'',
			buyTypes:0,
			phones:'',
			totalPrices:null,
			carPrices:null,
			necPrices:null,
			vehiclePurchaseTaxeses:null,
			vehicleVesselTaxs:420,
			displacements:1,
			salis:950,
			seatCountFlags:0,
			regPrices:500,
			downPayments:null,
			downPaymentRatios:30,
			payMonthlys:null,
			loanTerms:36,//传值还款年限
			loanLimits:null,
			interestRates:0.0525,
			interests:null,
			sendFlags:0,
            id:'',
            carAllNames:'请选择车款',
            totalPricesShow:'',
            carPricesShow:'',
            vehiclePurchaseTaxesesShow:'',
            salisShow:'',
            vehicleVesselTaxsShow:'',
            regPricesShow:'',
            downPaymentsShow:'',
            payMonthlysShow:'',
            loanLimitsShow:'',
            interestsShow:'',
            necPricesShow:''
//          timingTransmission:''
		}
	},
//	computed: {
//	    // 计算属性的 getter
//	    prices: function () {
//	      // `this` 指向 vm 实例
//	      if(self.buyTypes==0){
//				//全款总价
//				return parseFloat(self.carPrices)+self.vehiclePurchaseTaxeses+self.salis+self.vehicleVesselTaxs+self.regPrices;
//			}else{
//				//全款总价
//				return self.downPayments+self.interests+self.loanLimits;
//			}
//	    }
//	    
//	 },
	watch:{
		carPricesShow:function(val){
			var self = this;
			if(val==''||val==null){
				this.carPricesShow=0;
				this.carPrices=this.carPricesShow;
			}else{
				this.carPricesShow = val;
				this.carPrices=self.toNum(this.carPricesShow);
				console.log(this.carPrices);
			}
//			console.log(this.carPrices);
//			console.log(self.buyTypes);
			this.compute();
		},
		downPaymentRatios:function(val){
			var self = this;
			this.downPaymentRatios = val;
			console.log(this.downPaymentRatios);
			this.compute();
		},
		loanTerms:function(val){
			var self = this;
			this.loanTerms = val;
			console.log(this.loanTerms);
			this.compute();
		},
		salis:function(val){
			var self = this;
			this.salis = val;
			console.log(this.salis);
			this.compute();
		},
		vehicleVesselTaxs:function(val){
			var self = this;
			this.vehicleVesselTaxs = val;
			console.log(this.vehicleVesselTaxs);
			this.compute();
		},
		necPricesShow:function(val){
			var self = this;
			if(val==''||val==null){
				this.necPricesShow=0;
				this.necPrices=this.necPricesShow;
			}else{
				this.necPricesShow = val;
				this.necPrices=self.toNum(this.necPricesShow);
			}
			
//			console.log(this.carPrices);
//			console.log(self.buyTypes);
			this.compute();
		},
		vehiclePurchaseTaxesesShow:function(val){
			var self = this;
			if(val==''||val==null){
				this.vehiclePurchaseTaxesesShow=0;
				this.vehiclePurchaseTaxeses=this.vehiclePurchaseTaxesesShow;
			}else{
				this.vehiclePurchaseTaxesesShow = val;
				this.vehiclePurchaseTaxeses=self.toNum(this.vehiclePurchaseTaxesesShow);
			}
			
//			console.log(this.carPrices);
//			console.log(self.buyTypes);
			this.compute();
		},
		regPricesShow:function(val){
			var self = this;
			if(val==''||val==null){
				this.regPricesShow=0;
				this.regPrices=this.regPricesShow;
			}else{
				this.regPricesShow = val;
				this.regPrices=self.toNum(this.regPricesShow);
			}
//			console.log(this.carPrices);
//			console.log(self.buyTypes);
			this.compute();
		},
	},
	mounted:function(){
		var self = this;
		getCommonJsIns.initCSSNEW();
		getCommonJsIns.initSingleCSSNEW({
			cssURL: "/css/mapply/calculator/index.css?v=123"
		});
		
		//确保重要依赖的js加载完成
		getCommonJsIns.initJSNEW(this.webReady);
	},
	methods:{
		initFullInfo:function(showLoads,showResult,buyTypes,type){
				var self =this;
				self.showLoadContent=showLoads;
				self.pageStatus=showResult;
				self.buyTypes=buyTypes;
			    self.timingTransmission=type;
			
			if(self.buyTypes==0){
				//全款总价
				self.totalPrices=parseFloat(self.carPrices)+self.vehiclePurchaseTaxeses+self.salis+self.vehicleVesselTaxs+self.regPrices;
				self.totalPricesShow=self.toMoney(self.totalPrices);
			}else{
				//全款总价
				self.totalPrices=self.downPayments+self.interests+self.loanLimits;
				self.totalPricesShow=self.toMoney(self.totalPrices);
			}
			if(type==1){
				this.compute();
				self.submitSignup(buyTypes);
			}
			
		},
		webReady:function(){
			var self =this;
			self.bodyIsShow=true;

			MsgBus.$on('msgFullInfo', function(option){
				self.objData=option;
//				self.carBrand=self.objData.name+'-'+self.objData.styleName+'-'+self.objData.brandname;
				self.brandIds=option.brandid;
				self.brandNames=option.brandname;
				self.styleIds=option.styleid;
				self.styleNames=option.stylename;
				self.styleSeriesIds=option.styleSeriesid;
				self.styleSeriesNames=option.styleSeriesname;
				self.carAllNames=self.objData.name+'-'+self.objData.styleName+'-'+self.objData.brandname;
				self.carPrices=(option.referPrice*10000).toFixed(2);
				self.carPricesShow=self.toMoney(self.carPrices);
			})
			MsgBus.$on('msgInfoPay', function(option){
				
				self.downPaymentRatios=option;
			})
			MsgBus.$on('msgInfoYear', function(option){
				self.loanTerms=option;
			})
			MsgBus.$on('msgInfoInsu', function(option){
				
				self.seatCountFlags=option.id;
				self.salis=option.value;
			})
			MsgBus.$on('msgInfoTax', function(option){
				
				self.displacements=option.id;
				self.vehicleVesselTaxs=option.value;
			})
			MsgBus.$on('msgShow', function(option){
				self.phones=option.phone;	//手机号
				self.brandIds=option.brandId;	//Integer	品牌id
				self.brandNames=option.brandName;//品牌名称
				self.styleIds=option.styleId;	//Integer	款式id
				self.styleNames=option.styleName;	//	款式名称
				self.styleSeriesIds=option.styleSeriesId;//Integer	款式系列id
				self.styleSeriesNames=option.styleSeriesName;	//	款式系列名称
				self.buyTypes=option.buyType;	//Integer	0:全款, 1:贷款
				self.totalPrices=option.totalPrice;//BigDecimal	总价
				self.totalPricesShow=self.toMoney(self.totalPrices);
				self.carPrices=option.carPrice;	//BigDecimal	裸车价
				self.carPricesShow=self.toMoney(self.carPrices);
				self.necPrices=option.necPrice;	//BigDecimal	必要的花费
				self.necPricesShow=self.toMoney(self.necPrices);
				self.vehiclePurchaseTaxeses=option.vehiclePurchaseTaxes;//BigDecimal	车辆购置税
				self.vehiclePurchaseTaxesesShow=self.toMoney(self.vehiclePurchaseTaxeses);
				self.vehicleVesselTaxs=option.vehicleVesselTax;	//BigDecimal	车船使用税
				self.vehicleVesselTaxsShow=self.toMoney(self.vehicleVesselTaxs);
				self.displacements=option.displacement;	//Integer	排量 0:1.0L(含)以下, 1:1.0-1.6(含)以下, 2:1.6-2.0(含)以下, 3:2.0-2.5(含)以下, 4:2.5-3.0(含)以下，5:3.0-4.0(含)以下, 6:4.0L
				self.salis=option.sali;	//BigDecimal	交强险金额
				self.saliShow=self.toMoney(self.sali);
				self.seatCountFlags=option.seatCountFlag;	//Integer	座位数量 0:6座以下、1:6座以上
				self.regPrices=option.regPrice;	//BigDecimal	上牌费
				self.regPriceShow=self.toMoney(self.regPrice);
				self.downPayments=option.downPayment;	//BigDecimal	首付金额
				self.downPaymentsShow=self.toMoney(self.downPayments);
				if(option.downPaymentRatio==100){
					self.downPaymentRatios=30;//Integer	首付比例(乘以100)
				}else{
					self.downPaymentRatios=option.downPaymentRatio;//Integer	首付比例(乘以100)
				}
				if(option.loanTerm==0){
					self.loanTerms=36;	
				}else{
					self.loanTerms=option.loanTerm;	//Integer	贷款时长 单位:月
				}
				self.payMonthlys=option.payMonthly;	//BigDecimal	月付
				self.payMonthlysShow=self.toMoney(self.payMonthlys);
				self.loanLimits=option.loanLimit;	//BigDecimal	贷款额度
				self.loanLimitsShow=self.toMoney(self.loanLimits);
				self.interestRates=option.interestRate;	//Double	利率
				self.interests=option.interest;	//BigDecimal	利息
				self.interestsShow=self.toMoney(self.interests);
				self.sendFlags=option.sendFlag;//Integer	是否发送短信0：发送，1：不发送
				self.carAllNames=option.carAllName;
//				debugger
//				$("#insertCarinfo").test(self.carAllNames);
				self.id=option.id;
			})

		},
		//千位分隔符
		// 将金额类型转为数字类型
		toNum:function (str) {
			return str.replace(/\,|\￥/g, "");
		},
		//千位分隔符
		// 保留两位小数（四舍五入）
		toMoney:function(num) {
			var self=this;
			num = parseFloat(num).toString().split(".");
			num[0] = num[0].replace(new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'), "$1,");
			return num.join(".");
		},
//		toMoney:function(money){
//			function toNum(str) {
//				return str.replace(/\,|\￥/g, "");
//			}
//			// 保留两位小数（四舍五入）
//			function toPrice(num) {
//				num = parseFloat(toNum(num)).toString().split(".");
//				num[0] = num[0].replace(new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'), "$1,");
//				return num.join(".");
//			}
//		},
		compute:function(){
			var self = this;
//          裸车价取整
			console.log(this.carPrices);
			self.carPrices =Math.ceil(parseFloat(this.carPrices));
			self.carPricesShow=self.toMoney(self.carPrices);
			//首付比例乘以100
//			var downPayme=self.downPaymentRatio*100;
            //全款计算
			//购置税
			this.vehiclePurchaseTaxeses=Math.ceil(this.carPrices/1.17*0.1);
			this.vehiclePurchaseTaxesesShow=self.toMoney(this.vehiclePurchaseTaxeses);
			
			//较强险  六座以下
			this.salis=Math.ceil(this.salis);
			this.salisShow=self.toMoney(this.salis);
			// 车船税 1.0-1.6L的税费
			this.vehicleVesselTaxs=Math.ceil(this.vehicleVesselTaxs);
			this.vehicleVesselTaxsShow=self.toMoney(this.vehicleVesselTaxs);
			//上牌费用
			this.regPrices=Math.ceil(this.regPrices);
			this.regPricesShow=self.toMoney(this.regPrices);
			//六座以下
			this.seatCountFlags=this.seatCountFlags;
			//1.0-1.6L
			this.displacements=this.displacements;
			
			//必要花费
			this.necPrices=this.vehiclePurchaseTaxeses+this.salis+this.vehicleVesselTaxs+this.regPrices;
			this.necPricesShow=self.toMoney(this.necPrices)
			//贷款计算
			//	首付比例(乘以100)
			this.downPaymentRatios=this.downPaymentRatios;
//			self.downPaymentRatio*100;传给后台的值
            //贷款时长 单位:月
			this.loanTerms=this.loanTerms;
			
			if(this.loanTerms==12){
				this.interestRates=0.0485;
			}else if(this.loanTerms==24){
				this.interestRates=0.0525;
			}else if(this.loanTerms==36){
				this.interestRates=0.0525;
			}else if(this.loanTerms==48){
				this.interestRates=0.0525;
			}else if(this.loanTerms==60){
				this.interestRates=0.0525;
			}
			//利率
			this.interestRates=this.interestRates;
			//贷款额度
			this.loanLimits=Math.ceil(this.carPrices-(this.carPrices*(this.downPaymentRatios/100)));
			this.loanLimitsShow=self.toMoney(this.loanLimits);
			//月付
			//按照此基准利率：1年期4.85%；2年期5.25%；3年期5.25%；4年期5.25%；5年期5.25%
			//使用方法：
			//var vv = pmt(0.1,30,100000);
			this.payMonthlys=Math.ceil(self.pmt(this.interestRates,this.loanTerms,this.loanLimits));
			this.payMonthlysShow=self.toMoney(this.payMonthlys);
			//利息
			this.interests=Math.ceil(this.payMonthlys*this.loanTerms-this.loanLimits);
			this.interestsShow=self.toMoney(this.interests);
			//首付金额
			this.downPayments=Math.ceil(this.carPrices*this.downPaymentRatios/100)+this.vehiclePurchaseTaxeses+this.salis+this.vehicleVesselTaxs+this.regPrices;
			this.downPaymentsShow=self.toMoney(this.downPayments);


//			debugger
			if(this.buyTypes==0){
				//全款总价
				this.totalPrices=this.carPrices+this.vehiclePurchaseTaxeses+this.salis+this.vehicleVesselTaxs+this.regPrices;
				this.totalPricesShow=self.toMoney(this.totalPrices);
				console.log(this.totalPricesShow);
			}else{
				//贷款总价
				this.totalPrices=this.downPayments+this.interests+this.loanLimits;
				this.totalPricesShow=self.toMoney(this.totalPrices);
			}
		},
		subApply:function(data){
			var self = this;
			self.pmt();
			self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi+self.ajaxSubmit.allUrl.calcultorSend,
				type:"post",
				data:data,
//				contentType: 'application/json;charset=UTF-8',
				success:function(data){
					if(data.responseHeader.status == 200){
						Toast({
		                  message: "短信发送成功",
		                  position: 'middle',
		                  duration: 2000
		                });
						self.id=data.response.result.id;
						self.settlementBtn();
					}
					
				},
				error:function(){
					$("#tikect-sub").removeAttr("disabled");
					$("#signUpButton").removeAttr("disabled");
					Toast({
	                  message: "系统忙，请稍后",
	                  position: 'middle',
	                  duration: 2000
	                });
				}
			});
		},
		submitSignup:function(buyType){
			var self = this;
			self.phones=localStorage.getItem('ursePhone');
			self.compute();
			self.buyTypes=buyType;
			var data = {
					"phone":self.phones,	//手机号
					"brandId":self.brandIds,	//Integer	品牌id
					"brandName":self.brandNames,//品牌名称
					"styleId":self.styleIds,	//Integer	款式id
					"styleName":self.styleNames,	//	款式名称
					"styleSeriesId":self.styleSeriesIds,//Integer	款式系列id
					"styleSeriesName":self.styleSeriesNames,	//	款式系列名称
					"buyType":self.buyTypes,	//Integer	0:全款, 1:贷款
					"totalPrice":self.totalPrices,	//BigDecimal	总价
					"carPrice":self.carPrices,	//BigDecimal	裸车价
					"necPrice":self.necPrices,	//BigDecimal	必要的花费
					"vehiclePurchaseTaxes":self.vehiclePurchaseTaxeses,	//BigDecimal	车辆购置税
					"vehicleVesselTax":self.vehicleVesselTaxs,	//BigDecimal	车船使用税
					"displacement":self.displacements,	//Integer	排量 0:1.0L(含)以下, 1:1.0-1.6(含)以下, 2:1.6-2.0(含)以下, 3:2.0-2.5(含)以下, 4:2.5-3.0(含)以下，5:3.0-4.0(含)以下, 6:4.0L
					"sali":self.salis,	//BigDecimal	交强险金额
					"seatCountFlag":self.seatCountFlags,	//Integer	座位数量 0:6座以下、1:6座以上
					"regPrice":self.regPrices,	//BigDecimal	上牌费
					"downPayment":self.downPayments,	//BigDecimal	首付金额
					"downPaymentRatio":	self.downPaymentRatios,//Integer	首付比例(乘以100)
					"payMonthly":self.payMonthlys,	//BigDecimal	月付
					"loanTerm":self.loanTerms,	//Integer	贷款时长 单位:月
					"loanLimit":self.loanLimits,	//BigDecimal	贷款额度
					"interestRate":self.interestRates,	//Double	利率
					"interest":self.interests,	//BigDecimal	利息
					"sendFlag":1,	//Integer	是否发送短信0：发送，1：不发送
			};
			self.subApply(data);
		},
     unfold:function(){
     	if(this.isTakeupCon){
     		this.isTakeupCon=false;
     	}else{
     		this.isTakeupCon=true;
     	}
     	
     },
     settlementBtn:function(type){
        	var self=this;
        	
        	if(self.timingTransmission&&!type){
        		self.state=2;
        		var obj={
	        		state:self.state,
	        		pageStatus:self.pageStatus,
	        		showLoadinfo:self.showLoadContent,
        			brandNames:self.brandNames,
	        		styleNames:self.styleNames,
	        		styleSeriesNames:self.styleSeriesNames,
	        		ids:self.id,
//	        		buyTypes:self.buyTypes,
//	        		totalPrices:self.totalPrices,
//	        		carPrices:self.carPrices,
//	        		necPrices:self.necPrices,
//	        		vehiclePurchaseTaxeses:self.vehiclePurchaseTaxeses,
//	        		vehicleVesselTaxs:self.vehicleVesselTaxs,
//	        		salis:self.salis,
//	        		regPrices:self.regPrices
	        		
        		};
        	}else{
        		self.state=type;
        		var obj={
	        		state:self.state,
	        		pageStatus:self.pageStatus,
	        		showLoadinfo:self.showLoadContent,
	        		
	        	};
        	}
			this.$emit('childFullInfo', obj);
			
        },
        pmt:function(rate,term,financeAmount){
		//计算月供
		    var v = (1+(rate/12)); 
		
		    var t = (-(term/12)*12); 
		
		    var result=(financeAmount*(rate/12))/(1-Math.pow(v,t));
		
		    return result;
		
		},
		
	},
//	watch:{			//prop传值监听
//		result:{
//			deep:true,
//			handler:function(val){
//				if(val){
//					console.log(val);
//					this.pageStatus = val.pageStatus;
//					this.showLoadContent = val.showLoadContent;
//				}
//			}
//		}
//	}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/calculator/fullInformation/fullInformation.vue